var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('a',{attrs:{"href":"https://dsglobaloffshoreengineering.godaddysites.com/","target":"_blank"}},[_c('i',{staticClass:"el-icon-thumb"}),_vm._v("Singapore Branch Official website")])])
}]

export { render, staticRenderFns }